var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.page,{tag:"component",attrs:{"errorType":_vm.errorType,"warningType":_vm.warningType},on:{"navigate":_vm.navigate,"reload":_vm.check}})
}
var staticRenderFns = []

export { render, staticRenderFns }